// Components
const ModalOrdersModifyTrackingNumber = () =>
    import(
        /* webpackPrefetch: true, webpackChunkName: "modal-orders-modify-tracking-number"*/ "@/app/views/main-view/orders/containers/modals/modal-orders-modify-tracking-number/modal-orders-modify-tracking-number.vue"
    );
const ModalOrderDetails = () =>
    import(
        /* webpackPrefetch: true, webpackChunkName: "modal-order-details"*/ "@/app/views/main-view/orders/containers/modals/modal-order-details/modal-order-details.vue"
    );
const ModalDisapproveCancellationRequest = () =>
    import(
        /* webpackPrefetch: true, webpackChunkName: "modal-disapprove-cancellation-request"*/ "@/app/views/main-view/orders/containers/modals/modal-disapprove-cancellation-request/modal-disapprove-cancellation-request.vue"
    );

// Mixins
import { tableMixins } from "@/app/mixins/utils/table-mixins.js";
import { toastMessageMixins } from "@/app/mixins/utils/toast-message-mixins.js";
import { productMixins } from "@/app/mixins/modules/product-mixins";

// Constants
import { STATUS_CODES, TRANSACTION_STATUS } from "@/app/constants/constants";

// Services
import OrdersAPI from "@/app/services/main/orders/orders-service.js";
import PaymentAPI from "@/app/services/main/payment/payment-service.js";

// Events
import EventBus from "@/app/bus/event-bus.js";

let preFilterData;
export const orderMixins = {
    components: {
        ModalOrdersModifyTrackingNumber,
        ModalOrderDetails,
        ModalDisapproveCancellationRequest,
    },
    mixins: [tableMixins, productMixins, toastMessageMixins],
    data() {
        return {
            isAPILoading: false,
            isCreatingTracker: false,
            modifyMode: "",
            selectedOrder: {},
            // sorting
            desc: true,
        };
    },
    computed: {
        getFromUsersFilter() {
            return this.$store.getters.getFromUsersFilter;
        },
        isPreFilterMode() {
            return this.$store.getters.getOrdersPreFilterMode;
        },
        getFromSubscriptionData(){
            return this.$store.getters.getSubscriptionFilterData
        }
    },
    async created() {
        await EventBus.$on("orders", async (data) => {
            preFilterData = data;
        });
        this.setPreFilters();
        this.getTableContent();
    },
    activated() {
        // this lifecycle method will only be called for components under keep-alive
        this.setPreFilters();
        this.getTableContent();
	},
    beforeDestroy() {
        if (!this.getFromUsersFilter) {
            this.$store.commit("setOrdersPreFilterMode", false);
            this.$store.commit("clearFromUsersFilter");
            EventBus.$off("orders", () => {});
        }
    },
    methods: {
        setPreFilters() {
            if (this.isPreFilterMode) {
                const filtersToUse = this.getFromUsersFilter ? this.getFromUsersFilter :  preFilterData ? preFilterData : this.getFromSubscriptionData
                const { emailAddress, petName, owner } = filtersToUse;

                this.columnsFilter["f_ownerEmail"] = emailAddress;
                this.columnsFilter["f_petName"] = petName;
                this.columnsFilter["f_fullName"] = owner;

                this.$refs.filter_petName[0].value = petName;
                this.$refs.filter_fullName[0].value = owner;
            }
            this.$store.commit("setOrdersPreFilterMode", false);
        },
        getTableContent(fromFilter, page = this.page, limit = this.limit, sortBy = this.sortBy, desc = this.desc) {
            page = fromFilter ? 1 : this.page;
            this.getOrdersList({ page, limit, sortBy, desc });
        },
        getOrdersList(queryParams) {
            // search filters
            if (this.columnsFilter) {
                const {
                    f_id,
                    f_fullName,
                    f_ownerEmail,
                    f_shippingAddress,
                    f_petName,
                    f_breedName,
                    f_totalPrice,
                    f_status,
                    f_trackingNumber,
                    f_paymentMethod,
                } = this.columnsFilter;

                if (f_id) {
                    queryParams["f_id"] = f_id;
                }

                if (f_fullName) {
                    queryParams["f_fullName"] = f_fullName;
                }

                if (f_ownerEmail) {
                    queryParams["f_emailAddress"] = f_ownerEmail;
                }

                if (f_shippingAddress) {
                    queryParams["f_shippingAddress"] = f_shippingAddress;
                }

                if (f_petName) {
                    queryParams["f_petName"] = f_petName;
                }

                if (f_totalPrice) {
                    queryParams["f_totalPrice"] = f_totalPrice;
                }

                if (f_status) {
                    queryParams["f_status"] = f_status;
                }

                if (f_trackingNumber) {
                    queryParams["f_trackingNumber"] = f_trackingNumber;
                }

                if (f_breedName) {
                    queryParams["f_breedName"] = f_breedName;
                }

                if (f_paymentMethod) {
                    queryParams["f_paymentMethod"] = f_paymentMethod;
                }
            }

            // This is only to show the PENDING orders
            if (this.$route.name === "Orders Pending") {
                queryParams["f_pendingOrder"] = "true";
            }

            // Filter for user orders in User Page
            if (this.userId) {
                queryParams["f_userId"] = this.userId;
            }

            this.isAPILoading = true;

            OrdersAPI.getOrders(queryParams)
                .then((res) => {
                    if (res.status === STATUS_CODES.SUCCESS) {
                        this.tableContent = {
                            tableData: res.data.data,
                            paginationData: res.data.pagination,
                        };
                        EventBus.$emit("getOrderCount");
                    } else {
                        this.showAPIErrorToast("Unable to get order list.", res);
                    }
                    this.isAPILoading = false;
                })
                .catch(() => {
                    this.showGenericErrorToast();
                    this.isAPILoading = false;
                });
        },
        showModifyTrackingModal(order, mode) {
            this.selectedOrder = order;
            this.modifyMode = mode;

            setTimeout(() => {
                this.$refs.modalModifyTracking.openModal();
            }, 50);
        },
        showOrderDetailsModal(orderId) {
            this.$router.push(`/orders/${orderId}/view`);
        },
        showModalDisapprove(orderDetails) {
            this.$refs.modalDisapprove.openModal(orderDetails);
        },
        getClassByStatus(status) {
            const { REQUEST_CANCELLATION, CANCELLED, REFUNDED, DELIVERED, FAILED } = TRANSACTION_STATUS;

            switch (status) {
                case DELIVERED:
                    return "text-success";

                case REQUEST_CANCELLATION:
                    return "text-warning";

                case CANCELLED:
                case REFUNDED:
                case FAILED:
                    return "text-danger";

                default:
                    return "text-primary";
            }
        },
        handleRefreshTableContent() {
            this.getTableContent(false);
        },
        showRefundConfirmationModal(orderId) {
            let modalContent = '<div class="d-flex align-items-center flex-column">';
            modalContent +=
                '<p class="mb-0 my-2" style="color: #ff801e !important" >Are you sure that the LatitudePay payment has been successfully refunded to the user?</p>';
            this.$swal({
                titleText: `Mark Order #${orderId} as Refunded`,
                html: modalContent,
                confirmButtonText: "Confirm",
                showCancelButton: true,
                cancelButtonText: "Cancel",
                reverseButtons: true,
				showCloseButton: true,
            }).then((result) => {
                if (result.value) {
                    this.isAPILoading = true;

                    const bodyParams = { status: TRANSACTION_STATUS.REFUNDED };
                    const { SUCCESS_LATITUDE_PAY_REFUND, ERROR_MARK_ORDER_AS_REFUNDED } = this.toastMessages.order();

                    // Call the API endpoint to update the order status
                    OrdersAPI.putUpdateOrderStatus(orderId, bodyParams)
                        .then((res) => {
                            if (res.status === STATUS_CODES.SUCCESS_NO_CONTENT) {
                                this.showCustomSuccessToast(SUCCESS_LATITUDE_PAY_REFUND, "");
                                this.getTableContent();
                            } else {
                                this.showAPIErrorToast(ERROR_MARK_ORDER_AS_REFUNDED, res);
                            }
                            this.isActionAPILoading = false;
                        })
                        .catch(() => {
                            this.showGenericErrorToast();
                            this.isActionAPILoading = false;
                        });
                }
            });
        },
        showDeliveredConfirmationModal(orderId) {
            this.$swal({
                titleText: `Mark Order as Delivered`,
                html: `<p>Are you sure you want to mark order number <strong>${orderId}</strong> as <strong>DELIVERED</strong>?</p>`,
                confirmButtonText: "Confirm",
                showCancelButton: true,
                cancelButtonText: "Cancel",
                reverseButtons: true,
				showCloseButton: true,
            }).then((result) => {
                if (result.value) {
                    this.isAPILoading = true;

                    const bodyParams = { status: TRANSACTION_STATUS.DELIVERED };
                    const { SUCCESS_MARKED_ORDER_AS_DELIVERED, ERROR_MARK_ORDER_AS_DELIVERED } =
                        this.toastMessages.order();

                    // Call the API endpoint to update the order status
                    OrdersAPI.putUpdateOrderStatus(orderId, bodyParams).then((res) => {
                        if (res.status === STATUS_CODES.SUCCESS_NO_CONTENT) {
                            // Refresh table data
                            this.getTableContent();

                            // Show success message
                            this.showCustomSuccessToast(SUCCESS_MARKED_ORDER_AS_DELIVERED);
                        } else {
                            // Show error message
                            this.showAPIErrorToast(ERROR_MARK_ORDER_AS_DELIVERED, res);
                        }

                        this.isAPILoading = false;
                    });
                }
            });
        },
        deleteDogOrder(order) {
            this.$swal({
                title: "Delete Pending Order",
                text: `Are you sure you want to delete this pending order #${order.id}?`,
                confirmButtonText: "Confirm",
                showCancelButton: true,
                cancelButtonText: "Cancel",
                reverseButtons: true,
				showCloseButton: true,
            }).then((result) => {
                if (result.value) {
                    this.isAPILoading = true;
                    OrdersAPI.deletePendingDogPurchaseOrders(order.id)
                        .then((res) => {
                            this.isAPILoading = false;

                            this.handleRefreshTableContent();

                            this.showCustomSuccessToast(`Successfully pending order #${order.id}!`);
                        })
                        .catch(() => {
                            this.showGenericErrorToast();
                            this.isAPILoading = false;
                        });
                }
            });
        },
        reProcessDogOrder(order) {
            PaymentAPI.putPaymentStatus(order.id)
                .then((res) => {
                    this.isAPILoading = false;
                    if (res.status === 400 || res.status === 500 || res.status === 404) {
                        this.showCustomErrorToast(null, res.data.errors[0].message);
                    } else {
                        if (res.data.status === "DECLINED") {
                            this.showCustomErrorToast(null, res.data.message);
                        } else {
                            this.showCustomSuccessToast(`The order #${order.id} was successfully updated!`);
                        }
                    }
                    this.handleRefreshTableContent();
                })
                .catch(() => {
                    this.showGenericErrorToast();
                    this.isAPILoading = false;
                });
        },
        formatPaymentMethod(paymentMethod){
			if(!paymentMethod) return "";

			const paymentMethods = paymentMethod.map(method => {
				if(method.name.toLowerCase() === "stripe"){
					return "Credit Card";
				}

				return method.name;
			});

			return paymentMethods.join(" & ");
		}
    },
};
